// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import TypographyStyle from "@insite/mobius/Typography/TypographyStyle";
import { shipmentTrackingNumbersStyles } from "@rpsc/App/Components/Order/ShipmentTrackingNumbers";
import xOrderInformationStyles from "@rpsc/App/SharedStyles/MyAccountPages/Details/OrderInformationStyles";
import { css } from "styled-components";


shipmentTrackingNumbersStyles.wrapper = {
    css: css`
        display: flex;
        flex-wrap: wrap;
    `
}

shipmentTrackingNumbersStyles.label = {
    ...xOrderInformationStyles.label
}
shipmentTrackingNumbersStyles.links = {
    css: css`
        a:not(:last-child)::after, ${TypographyStyle}:not(:last-child)::after {
            content: ","
        }
        margin-right: 8px;
        @media print {
            display: none;
        }
    `
}

shipmentTrackingNumbersStyles.linksPrint = {
    css: css`
        display: none;
        @media print {
            display: inline;
            a:not(:last-child)::after, ${TypographyStyle}:not(:last-child)::after {
                content: ","
            }
        }
    `
}

shipmentTrackingNumbersStyles.link = {
    mergeCss: true,
    typographyProps: {
        ...xOrderInformationStyles.value
    }
}

shipmentTrackingNumbersStyles.showMore = {
    typographyProps: {
        ...xOrderInformationStyles.value
    }
}